import { useApolloClient } from '@apollo/client';
import React, { useEffect, useMemo } from 'react';
import { ResourceMatchesStatus } from '~/types';
import { useMeContext } from '~/modules/me/useMeContext';
import { USER_ACCESS_ROLE } from '~/modules/common/enums';
import { resourceMatchesFragment } from '~/modules/resourcing/common/fragments';
import useResourceRequestMatchingSubscription from './useResourceRequestMatchingSubscription';

const ResourceRequestMatchingProcessedAlert = () => {
  const client = useApolloClient();
  const { userAccessRoles, featureFlags } = useMeContext();
  const hasResourceManagerRole = useMemo(
    () => userAccessRoles.some(r => r === USER_ACCESS_ROLE.RESOURCE_MANAGER),
    [userAccessRoles]
  );
  const { id, resourceMatches } = useResourceRequestMatchingSubscription({
    skipSubscription:
      !featureFlags.isPsaPraaResourceMatchingEnabled || !hasResourceManagerRole
  });

  useEffect(() => {
    if (id && hasResourceManagerRole) {
      client.writeFragment({
        id: `ResourceRequest:{"id":"${id}"}`,
        fragment: resourceMatchesFragment,
        variables: {
          resourceMatchesPage: 1,
          resourceMatchesPageSize: 1,
          isPsaPraaResourceMatchingEnabled:
            featureFlags.isPsaPraaResourceMatchingEnabled
        },
        data: {
          resourceMatches: resourceMatches.length ? [resourceMatches[0]] : [],
          resourceMatchesStatus: ResourceMatchesStatus.Completed
        }
      });
    }
  }, [
    client,
    id,
    resourceMatches,
    hasResourceManagerRole,
    featureFlags.isPsaPraaResourceMatchingEnabled
  ]);

  return <></>;
};

export default ResourceRequestMatchingProcessedAlert;
